(() => {
  if (window.myocProductCardLoaded) return;
  window.myocProductCardLoaded = true;

  const parseHTML = (html, selector) => {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  };

  const openDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.classList.remove('is-empty');

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('active', 'animate');
      document.body.classList.add('overflow-hidden');
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-myoc-atc]');
    if (!button || button.disabled || button.dataset.loading === 'true') return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.dataset.loading = 'true';
    button.classList.add('is-loading');

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();
      if (!response.ok) throw data;

      if (data.sections && data.sections['cart-drawer']) {
        const currentDrawer = document.querySelector('cart-drawer');
        const newDrawer = parseHTML(data.sections['cart-drawer'], 'cart-drawer');

        if (currentDrawer && newDrawer) {
          currentDrawer.outerHTML = newDrawer.outerHTML;
        }
      }

      if (data.sections && data.sections['cart-icon-bubble']) {
        const currentBubble = document.querySelector('#cart-icon-bubble');
        const newBubble = parseHTML(data.sections['cart-icon-bubble'], '#cart-icon-bubble');

        if (currentBubble && newBubble) {
          currentBubble.outerHTML = newBubble.outerHTML;
        }
      }

      requestAnimationFrame(openDrawer);
    } catch (error) {
      console.error('[MYOC ATC ERROR]', error);
      window.location.href = `${window.Shopify.routes.root}cart`;
    } finally {
      button.dataset.loading = 'false';
      button.classList.remove('is-loading');
    }
  });
})();